import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isEmpty from 'lodash/isEmpty';
import { formatImageCloudinary } from '~/helpers/image-helper';
import DescriptionLine from '~/components/organisms/Product/DescriptionLine.vue';
import RichContentMediaText from '~/components/organisms/Product/RichContentMediaText.vue';

const ProductPreview = () => import('~/components/library/Product/ProductPreview.vue');

export default {
  components: {
    DescriptionLine,
    RichContentMediaText,
    ProductPreview
  },
  props: {
    crossRange: {
      type: Array,

      default() {
        return [];
      }

    },
    collectionDescription: {
      type: String,

      default() {
        return '';
      }

    },
    translationsDescription: {
      type: String,
      default: ''
    },
    translationsLineDescription: {
      type: String,
      default: ''
    },
    translationsLineName: {
      type: String,
      default: ''
    },
    additionalContent: {
      type: Object,

      default() {
        return {};
      }

    }
  },

  data() {
    return {
      mobile: true
    };
  },

  computed: {
    hasAdditionalContent() {
      return !isEmpty(this.additionalContent);
    },

    hasLineName() {
      return !!this.translationsLineName;
    },

    currentImages() {
      return Object.values(this.crossRange).slice(0, 6).map(img => _objectSpread({}, img, {
        srcset: this.formatImageUrl(img.product_image, 200)
      }));
    },

    description() {
      if (!this.translationsDescription && !this.collectionDescription) {
        return null;
      }

      return this.translationsDescription;
    }

  },

  mounted() {
    this.mobile = this.isMobile();
  },

  methods: {
    formatImageUrl(path, height) {
      const url = path;
      return formatImageCloudinary(url.replace('%height%', height), ['e_trim', "w_".concat(height)]);
    }

  }
};